import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey:            "AIzaSyBxdJXylxJPFXdmI3mjcMAY7BX8QZS4BCE",
  authDomain:        "arova-advisory.firebaseapp.com",
  projectId:         "arova-advisory",
  storageBucket:     "arova-advisory.firebasestorage.app",
  messagingSenderId: "141767288551",
  appId:             "1:141767288551:web:8e05cd4433b81d6d3b2442",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);